import React from 'react';
import createSvgIcon from '../utils/createSvgIcon';

export default createSvgIcon(React.createElement(
  'g',
  null,
  React.createElement(
    'title',
    null,
    'Trace Icons_1-3'
  ),
  React.createElement('path', { d: 'M16,21.68a2,2,0,0,0,1.46-.6L22.53,16l-.92-.92-5,5v-14h-1.3V20l-5-5L9.47,16l5.07,5.08A2,2,0,0,0,16,21.68Z' }),
  React.createElement('path', { d: 'M25.43,20.75v3.61c0,.43-.68.91-1.59.91H8.16c-.94,0-1.59-.48-1.59-.91V20.75H5.27v3.61c0,1.24,1.27,2.21,2.89,2.21H23.84c1.62,0,2.89-1,2.89-2.21V20.75Z' })
));